import * as React from "react";
import {withAuthWrapperComponent} from "@/app/auth/WithAuthWrapperComponent";
import CompanyOverviewPage from "@/pages/company-overview-page/CompanyOverviewPage";

const CompanyUnverifiedPage = () => <CompanyOverviewPage unverified />;

export default withAuthWrapperComponent(CompanyUnverifiedPage);
